<template>
  <div>
    <a-descriptions title="Info Shift / Thông tin ca làm việc" :column="1">
      <a-descriptions-item label="Shift / Ca làm việc">
        {{ workShift.title }} ->
        <span class="new-shift"> {{ newWorkShift.title }} </span>
      </a-descriptions-item>
      <a-descriptions-item label="Code / Mã">
        {{ workShift.code }} ->
        <span class="new-shift"> {{ newWorkShift.code }} </span>
      </a-descriptions-item>
      <a-descriptions-item label="Weekday / Ngày làm việc">
        <span v-for="(day, index) in dayInWeeks" :key="index">
          <span>
            {{ convertDayInWeekToNameDate(day) }}
            <span v-if="index < dayInWeeks.length - 1">,</span>
          </span>
        </span>
        ->
        <span
          class="new-shift"
          v-for="(day, index) in newDayInWeeks"
          :key="index + '_new'"
        >
          <span>
            {{ convertDayInWeekToNameDate(day) }}
            <span v-if="index < dayInWeeks.length - 1">,</span>
          </span>
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Working Time / Giờ làm việc">
        {{ workShift.startTime | formatTime }} -
        {{ workShift.endTime | formatTime }}
        ->
        <span class="new-shift">
          {{ newWorkShift.startTime | formatTime }} -
          {{ newWorkShift.endTime | formatTime }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Break Time / Nghỉ giữa giờ">
        {{ workShift.startBreakTime | formatTime }} -
        {{ workShift.endBreakTime | formatTime }}
        ->
        <span class="new-shift">
          {{ newWorkShift.startBreakTime | formatTime }} -
          {{ newWorkShift.endBreakTime | formatTime }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="Working hours / Tổng số giờ làm việc">
        {{ workShift.duration }}
        ->
        <span class="new-shift">
          {{ newWorkShift.duration }}
        </span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import CollapseCard from "@/components/common/collapseCard";
import { dayOfWeeks } from "./constant/default";
export default {
  components: {},
  props: {
    workShift: {
      type: Object,
      required: true,
    },
    newWorkShift: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dayInWeeks: [],
      newDayInWeeks: [],
    };
  },
  created() {
    if (this.workShift?.dayInWeeks) {
      this.dayInWeeks = JSON.parse(this.workShift.dayInWeeks);
      this.newDayInWeeks = JSON.parse(this.newWorkShift.dayInWeeks);
    }
  },
  methods: {
    convertDayInWeekToNameDate(dayInWeek) {
      if (dayOfWeeks?.length > 0) {
        const index = dayOfWeeks.findIndex((e) => e.key === dayInWeek);
        if (index >= 0) {
          return dayOfWeeks[index].Title;
        }
      }

      return "Không có ngày";
    },
  },
};
</script>
<style lang="css" scoped>
.new-shift {
  color: #32cd32 !important;
}
</style>
